import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';
import qs from 'qs';

import PanelHeader from './PanelHeader';
import PanelFooter from './PanelFooter';
import PanelFilterGroupCollection from '../PanelFilterGroupCollection';

import styles from './styles.js';

import {
    fetchActions,
    filterActions
} from '../../../actions';
import { concatMap, createFiltersQueryStringFromArray } from '../../../../../methods';

import { isAllDaySelected } from '../../../selectors';

class PanelSmallScreen extends Component {
    static propTypes = {
        allDaySelected: PropTypes.bool.isRequired,
        apiUrl: PropTypes.string.isRequired,
        applyFilterGroupCollections: PropTypes.func.isRequired,
        clearAllFilters: PropTypes.func.isRequired,
        fetchSearchResults: PropTypes.func.isRequired,
        filterGroupCollections: PropTypes.array.isRequired,
        // setActiveFilterGroupCollection: PropTypes.func.isRequired,
        toggleFullScreenPanel: PropTypes.func.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        allDay: this.props.allDaySelected,
        expandedGroups: [],
        filterCount: 0,
        filterGroupCollections: this.props.filterGroupCollections,
        hasChanged: false,
        isCancelled: false
    }

    componentDidMount() {
        const { getFilterCount } = this;
        // const { setActiveFilterGroupCollection } = this.props;
        getFilterCount();
        // setActiveFilterGroupCollection();
    }

    componentWillUnmount() {
        const { applyFilterGroup } = this;
        applyFilterGroup();
    }

    applyFilterGroup = () => {
        const { filterGroupCollections, hasChanged, isCancelled, searchParams } = this.state;
        const { apiUrl, applyFilterGroupCollections, fetchSearchResults, trackingCookieId, userLang } = this.props;
        if (!isCancelled && hasChanged) {
            applyFilterGroupCollections(filterGroupCollections);
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const paramsQs = createFiltersQueryStringFromArray(searchParams, filterGroupCollections);
            fetchSearchResults(apiUrl, userLang, location, tag, paramsQs, trackingCookieId);
        }
    }

    clearAllFilters = () => {
        const { resetFilterGroupCollections } = this;
        const {
            apiUrl,
            clearAllFilters,
            fetchSearchResults,
            trackingCookieId,
            userLang
        } = this.props;
        resetFilterGroupCollections();
        clearAllFilters();
        const location = decodeURIComponent(window.location.pathname.split('/')[4]);
        const tag = {
            quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
        };
        const params = window.location.search.split('?')[1];
        const parsedParams = qs.parse(params);
        const clearedParams = {};
        for (const key in parsedParams) {
            if (key === 'tag' ||
            key === 'location' ||
            key === 'date' ||
            key === 'guests' ||
            key === 'lat' ||
            key === 'lon' ||
            key === 'ne_lat' ||
            key === 'ne_lon' ||
            key === 'sw_lat' ||
            key === 'sw_lon' ||
            key === 'page' ||
            key === 'min_price' ||
            key === 'max_price' ||
            key === 'lang') {
                clearedParams[key] = parsedParams[key];
            }
        }
        fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(clearedParams), trackingCookieId);
    }

    getFilterCount = () => {
        const { filterGroupCollections } = this.state;
        const filterCount = concatMap(
            concatMap(filterGroupCollections, filterGroupCollection =>
                filterGroupCollection.filterGroups.filter(filterGroup =>
                    filterGroup.inputType === 'checkbox' ||
                    filterGroup.inputType === 'toggle-switch' ||
                    filterGroup.inputType === 'radio' ||
                    filterGroup.inputType === 'increment' ||
                    filterGroup.inputType === 'slider'
                )
            ), filterGroup =>
                filterGroup.filters
        ).filter(filter => {
            if (filter.data.type === 'range') {
                const array = [];
                filter.data.values.map(value => {
                    filter.data.defaults.map(def => {
                        if (def.slug === value.slug && def.value !== value.value) {
                            array.push(value.value);
                        }
                    });
                });
                return array.length;
            }
            return filter.data.value !== filter.data.default;
        }).length;
        this.setState({ filterCount });
    }

    handleApply = () => {
        const { toggleFullScreenPanel } = this.props;
        toggleFullScreenPanel();
    }

    handleCancel = () => {
        const { toggleFullScreenPanel } = this.props;
        this.setState({ isCancelled: true }, () => {
            toggleFullScreenPanel();
        });
    }

    handleExpand = (expandedIndex, classId = null) => {
        const { expandedGroups } = this.state;
        let updatedExpandedGroups = [...expandedGroups];
        if (expandedGroups.filter(e => e.index === expandedIndex).length) {
            updatedExpandedGroups = expandedGroups.filter(e => e.index !== expandedIndex);
        } else if (classId !== null) {
            updatedExpandedGroups.push({
                index: expandedIndex,
                classId
            });
        }
        this.setState({ expandedGroups: updatedExpandedGroups });
    }

    handleExpanded = (expandedIndex, classId) => {
        const { expandedGroups } = this.state;
        const updatedExpandedGroups = expandedGroups.map(group => {
            if (group.index !== expandedIndex) {
                return group;
            }
            return {
                ...group,
                classId
            };
        });
        this.setState({ expandedGroups: updatedExpandedGroups });
    }

    resetFilterGroupCollections = () => {
        const { filterGroupCollections } = this.state;
        const updatedFitlerGroupCollections = filterGroupCollections.map(filterGroupCollection => {
            return {
                ...filterGroupCollection,
                filterGroups: filterGroupCollection.filterGroups.map(filterGroup => {
                    return {
                        ...filterGroup,
                        filters: filterGroup.filters.map(filter => {
                            if (typeof filter.data.value !== 'undefined' &&
                            typeof filter.data.default !== 'undefined') {
                                return {
                                    ...filter,
                                    data: {
                                        ...filter.data,
                                        value: filter.data.default
                                    }
                                };
                            } else if (filter.data.values && filter.data.defaults) {
                                const values = filter.data.values.map(value => {
                                    let newValue;
                                    filter.data.defaults.map(def => {
                                        if (def.slug === value.slug) {
                                            newValue = def.value;
                                        }
                                    });
                                    return {
                                        ...value,
                                        value: newValue
                                    };
                                });
                                return {
                                    ...filter,
                                    values
                                };
                            }
                        })
                    };
                })
            };
        });
        this.setState({
            filterCount: 0,
            filterGroupCollections: updatedFitlerGroupCollections
        });
    }

    setAllDay = () => {
        this.setState(prevState => {
            return ({
                allDay: !prevState.allDay,
                hasChanged: true
            });
        });
    }

    toggleFilter = filterGroupCollection => {
        const { getFilterCount } = this;
        const { filterGroupCollections } = this.state;
        const updatedFilterGroupCollections = filterGroupCollections.map(fGroupCollection => {
            if (fGroupCollection.id !== filterGroupCollection.id) {
                return fGroupCollection;
            }
            return {
                ...fGroupCollection,
                ...filterGroupCollection
            };
        });
        this.setState({
            filterGroupCollections: updatedFilterGroupCollections,
            hasChanged: true
        }, () => {
            getFilterCount();
        });
    }

    render() {
        const {
            clearAllFilters,
            handleApply,
            handleCancel,
            handleExpand,
            handleExpanded,
            setAllDay,
            toggleFilter
        } = this;
        const {
            allDay,
            expandedGroups,
            filterCount,
            filterGroupCollections
        } = this.state;
        const { allDaySelected } = this.props;
        return (
            <div>
                <div className={css(styles.outerContainer)}>
                    <div className={css(styles.panel)}>
                        <PanelHeader
                            filterCount={filterCount}
                            handleClose={handleCancel}
                            headerAction={clearAllFilters}
                        />
                        <div
                            className={css(
                                styles.panelContent,
                                styles.panelContent_full,
                                styles.panelContent_withFixedHeader,
                                styles.panelContent_withFooter
                            )}
                        >
                            <div className={css(styles.panelBody)}>
                                {filterGroupCollections.map((filterGroupCollection, index) => {
                                    return (
                                        <PanelFilterGroupCollection
                                            key={shortid.generate()}
                                            allDay={allDay}
                                            allDaySelected={allDaySelected}
                                            expandedGroups={expandedGroups}
                                            filterGroupCollection={filterGroupCollection}
                                            filterGroupCollectionIndex={index}
                                            handleExpand={handleExpand}
                                            handleExpanded={handleExpanded}
                                            setAllDay={setAllDay}
                                            toggleFilter={toggleFilter}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                        <PanelFooter
                            handleButtonClick={handleApply}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    allDaySelected: isAllDaySelected(state),
    apiUrl: state.config.apiUrl,
    searchParams: state.searchParams,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => {
    return {
        applyFilterGroupCollections: filterGroupCollections =>
            dispatch(filterActions.applyFilterGroupCollections(filterGroupCollections)),
        clearAllFilters: () =>
            dispatch(filterActions.clearAllFilters()),
        fetchSearchResults: (apiUrl, userLang, location, tag, params, trackingCookieId) =>
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId, true))
        // setActiveFilterGroupCollection: () =>
            // dispatch(filterActions.setActiveFilterGroupCollection(0))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelSmallScreen);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelSmallScreen/PanelSmallScreen.jsx